import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { I140FileUploadConfiguration, ImagilityBaseResponse, PrimaryData, ReferenceLibrary, TaskStep } from 'app-models';
import { AppServicesLibraryService } from 'app-services-library';
// import { APIJobDescription, DateValidators, deleteDialogConfigurations } from 'base-job-description-library';
import { CacheCountryListService } from 'cache-country-list';
import { DirtyFormGuard } from 'dirty-check-store';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'primeng/dynamicdialog';
import { ReferenceLibraryService } from 'reference-library';
import { Subject } from 'rxjs';
import { StepStatusUpdatePayloadService } from 'step-status-update-payload-service';
import { Injectable } from '@angular/core';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { select, Store } from '@ngrx/store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'dirty-check-store';
import * as errorUtils from 'error-message-utility';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import moment from 'moment';
import { take } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { APIJobDescription, DateValidators, deleteDialogConfigurations } from 'base-job-description-library';
import { APILCASOCCode } from 'base-lca-soc-code-library';
import { JobDescriptionLcaWorkLibraryService } from './job-description-lca-work-library.service';
import { CustomErrorToastComponent } from 'custom-error-toast';
@Component({
  selector: 'job-description-lca-work-library',
  templateUrl: 'job-description-lca-work-library.component.html',
  styles: [
  ]
})
export class JobDescriptionLcaWorkLibraryComponent implements OnInit {

  @Input()
  isForeignCompany: boolean;

  @Input()
  primaryData: PrimaryData;

  @Input()
  deleteAllDutie;

  @Input()
  addUpdateDuty;

  @Input()
  deleteDuty;

  @Input()
  deleteSubDuty;

  @Input()
  parentForm;

  @Input() isFromWizard;

  public jobDescriptionForm: FormGroup;
  jobDescription: any;
  subJobDuty: {
    id: number,
    duty: string,
    name: string,
  }[];
  disabledControls: boolean;
  // wageUnitType: ReferenceLibrary[];
  countryList: [];
  stateList: [];
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;
  titleSoc: string;

  observableSubscription$ = new Subject();

  addressList: [];
  address: FormArray;
  fileUploadConfigurations: I140FileUploadConfiguration;
  listDocumentTypes: ReferenceLibrary[];
  public inputData: PrimaryData;
  userType: string;
  isSimplify: boolean;
  lcaCodeId: any;

  constructor(
    public jobDescriptionBuilder: FormBuilder,
    public store: Store<any>,
    public apiService: APIJobDescription,
    public toastr: ToastrService,
    public stepStatusUpdatePayloadCostruction: StepStatusUpdatePayloadService,
    public guard: DirtyFormGuard,
    public cacheCountyService: CacheCountryListService,
    public referenceLibraryService: ReferenceLibraryService,
    public changeDetector: ChangeDetectorRef,
    public dialogService: DialogService,
    public customValidator: DateValidators,
    public appServicesLibraryService: AppServicesLibraryService,
    private jobDescriptionLcaWorkLibraryService: JobDescriptionLcaWorkLibraryService,
    public apiServiceSOC: APILCASOCCode
  ) {
    this.countryList = [];
    this.stateList = [];
    this.addressList = [];
    this.disabledControls = false;
  }

  public ngOnInit(): void {
    if (sessionStorage.getItem('isSimplify') && sessionStorage.getItem('isSimplify') == 'CWF') {
      this.isSimplify = true;
    } else {
      this.isSimplify = false;
    }
    this.inputData = this.primaryData;
    this.jobDescriptionForm = this.jobDescriptionBuilder.group({
      id: [null],
      address: this.jobDescriptionBuilder.array([]),
      workLocationTypeCode: [null, Validators.required],
      // caseId: [],
      // socCode1: [null],
      // socCode2: [null],
      // thisPastJob: [false],
      clientName: [null,this.clientNameRequired.bind(this)],
      clientEmail: [null],
      clientPhoneNo: [null],
      clientPhoneCountryCode: [this.isForeignCompany ? null : 'USA'],
      isMiddleVendor: [false],
      vendorList: this.jobDescriptionBuilder.array([])
    }, {
      // validator: this.customValidator.dateLessThan('startDate', 'endDate'),
    });
    // this.getWageUnitType();
    if (this.isForeignCompany) {
      this.cacheCountyService.getCountryWithoutUSA().subscribe(data => {
        if (data.length > 0) {
          this.countryList = data;
        }
      });
    } else {
      this.getCountries();
    }
    if (this.isFromWizard) {
      this.getJobDescription();
      this.fileUploadConfigurations = Object.assign({}, {
        disableControls: this.disabledControls,
        isDocumentTypeRequired: true,
        isDocumentUploadRequired: true,
        isViewEnabled: true,
        isDownloadEnabled: true,
        isDeleteEnabled: true,
        getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/`,
        postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/fileCategory/`,
        deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
        documentTypeDropdownCode: (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR',
        getDocTypeApiUrl: '/referenceLibrary/POSOFFRLTR'
        // getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/`,
        // postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/fileCategory/`,
        // deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
        // documentTypeDropdownCode: this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'OFFLTR'
      });
    }
    // Get Specific step details by passing step code
    this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }))
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: TaskStep) => {
        this.getJobDescription();
        this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
        this.stepDetails = data;
        this.fileUploadConfigurations = Object.assign({}, {
          disableControls: this.disabledControls,
          isDocumentTypeRequired: true,
          isDocumentUploadRequired: true,
          isViewEnabled: true,
          isDownloadEnabled: true,
          isDeleteEnabled: true,
          getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/`,
          postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/fileCategory/`,
          deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
          documentTypeDropdownCode: (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR',
          getDocTypeApiUrl: '/referenceLibrary/POSOFFRLTR'
          // getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/`,
          // postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/fileCategory/`,
          // deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
          // documentTypeDropdownCode: this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'OFFLTR'
        });
        this.toggleControlsStatus();
      });
  }

  createVendorDetailsItem(obj: any): void {
    const vendorItem = this.jobDescriptionBuilder.group({
      vendorName: [obj['vendorName'] ? obj['vendorName'] : ''],
      vendorLastName: [obj['vendorLastName'] ? obj['vendorLastName'] : ''],
      vendorFirstName: [obj['vendorFirstName'] ? obj['vendorFirstName'] : ''],
    });
    (this.jobDescriptionForm.controls['vendorList'] as FormArray).push(vendorItem);
  }

  addVendor() {
    this.createVendorDetailsItem({});
  }

  deleteVendor(vendorIndex) {
    (this.jobDescriptionForm.controls['vendorList'] as FormArray).removeAt(vendorIndex);
  }

  createAddressItem(obj: any) {
    const addressGroupItem = this.jobDescriptionBuilder.group({
      id: [obj.id],
      addressLine1: [obj && obj.addressLine1 ? obj.addressLine1 : '', Validators.required],
      addressLine2: [obj && obj.addressLine2 ? obj.addressLine2 : ''],
      addressLine2NoType: [null],
      addressTypeCode: 'WORK',
      beneficiaryId: [null],
      countryCode: [
        this.isForeignCompany ? obj.countryCode ? obj.countryCode : null : 'USA',
        this.isForeignCompany ? [Validators.required] : []],
      countryName: [null],
      doorNo: [null],
      locality: [null],
      state: [null],
      stateProvinceCode: [obj && obj.stateProvinceCode ? obj.stateProvinceCode : null],
      stateProvinceName: [obj && obj.stateProvinceName ? obj.stateProvinceName : null],
      stateList: [],
      streetNo: [null],
      city: [obj && obj.city ? obj.city : '', [Validators.required, Validators.pattern('[a-zA-Z ]*')]],
      postCode: [obj && obj.postCode ? obj.postCode : '', Validators.required],
      clientName: [obj && obj.clientName ? obj.clientName : null],
      clientEmail: [obj && obj.clientEmail ? obj.clientEmail : null],
      clientPhoneNo: [obj && obj.clientPhoneNo ? obj.clientPhoneNo : null],
      clientPhoneCode: [this.isForeignCompany ? null : 'USA'],
      type: [null],
      familyId: [null],
      companyId: [null],
      employeeId: [null],
      immigrationId: [null],
      workLocationId: [obj.workLocationId ? obj.workLocationId : 0],
      sequenceNo: [0]
    });

    if (this.jobDescriptionForm.get('workLocationTypeCode').value === 'TPARTY' ||
      this.jobDescriptionForm.get('workLocationTypeCode').value === 'INHSECLT') {
      addressGroupItem.get('clientName').setValidators(Validators.required);
    }
    if (this.jobDescriptionForm.get('workLocationTypeCode').value === 'INHSE') {
      addressGroupItem.get('clientName').clearValidators();
    }
    this.referenceLibraryService.getStatesFromStore(this.isForeignCompany ? obj.countryCode : 'USA')
      .pipe(take(1))
      .subscribe((states: any[]) => {
        if (states) {
          addressGroupItem.controls['stateList'].setValue(states);
          if (states && states.length > 0) {
            addressGroupItem.get('stateProvinceName').clearValidators();
            addressGroupItem.get('stateProvinceCode').setValidators(Validators.required);
          }
          else {
            addressGroupItem.get('stateProvinceName').setValidators(Validators.required);
            addressGroupItem.get('stateProvinceCode').clearValidators();
          }
          (this.jobDescriptionForm.controls['address'] as FormArray).push(addressGroupItem);
        } else {
          this.referenceLibraryService.getStatesFromApi(this.isForeignCompany ? obj.countryCode : 'USA')
            .pipe(take(1))
            .subscribe((data: any[]) => {
              addressGroupItem.controls['stateList'].setValue(data);
              if (data && data.length > 0) {
                addressGroupItem.get('stateProvinceName').clearValidators();
                addressGroupItem.get('stateProvinceCode').setValidators(Validators.required);
              }
              else {
                addressGroupItem.get('stateProvinceName').setValidators(Validators.required);
                addressGroupItem.get('stateProvinceCode').clearValidators();
              }
              (this.jobDescriptionForm.controls['address'] as FormArray).push(addressGroupItem);
            });
        }
      });
  }

  getStateList(countryCode: string = 'USA', item) {
    this.referenceLibraryService.getStatesFromStore(countryCode)
      .pipe(take(1))
      .subscribe((states: any[]) => {
        if (states) {
          item.controls['stateList'] = states;
        } else {
          this.referenceLibraryService.getStatesFromApi(countryCode)
            .pipe(take(1))
            .subscribe((data: any[]) => {
              item.controls['stateList'] = data;
            });
        }
      });
  }

  handleCountryChange(countryCode: string, item: FormGroup, flag: boolean = false) {
    if (flag) {
      item.controls['stateProvinceCode'].setValue(null);
      item.controls['stateProvinceName'].setValue(null);
    }
    this.referenceLibraryService.getStatesFromStore(countryCode)
      .pipe(take(1))
      .subscribe((states: any[]) => {
        if (states) {
          item.controls['stateList'].setValue(states);
          if (states && states.length > 0) {
            item.get('stateProvinceName').clearValidators();
            item.get('stateProvinceCode').setValidators(Validators.required);
          }
          else {
            item.get('stateProvinceName').setValidators(Validators.required);
            item.get('stateProvinceCode').clearValidators();
          }
          this.changeDetector.markForCheck();
        } else {
          this.referenceLibraryService.getStatesFromApi(countryCode)
            .pipe(take(1))
            .subscribe((data: any[]) => {
              item.controls['stateList'].setValue(data);
              if (data && data.length > 0) {
                item.get('stateProvinceName').clearValidators();
                item.get('stateProvinceCode').setValidators(Validators.required);
              }
              else {
                item.get('stateProvinceName').setValidators(Validators.required);
                item.get('stateProvinceCode').clearValidators();
              }
              this.changeDetector.markForCheck();
            });
        }
      });
  }

  public afterViewInit() {
    this.jobDescriptionForm.valueChanges
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(() => {
        if (this.jobDescriptionForm.dirty) {
          this.store.dispatch(new MarkDirtyFormAction({
            dirty: true
          }));
        } else {
          this.store.dispatch(new MarkCleanFormAction({
            dirty: false
          }));
        }
      });
  }

  getAddressFormArray() {
    return (this.jobDescriptionForm.controls['address'] as FormArray).controls;
  }

  getVendorListFormArray() {
    return (this.jobDescriptionForm.controls['vendorList'] as FormArray).controls;
  }

  buildDutyList(item) {
    const subJobDuty = [];
    if (item.subduty && item.subduty.length > 0) {
      item.subduty.forEach(element => {
        subJobDuty.push(this.buildSubDutyList(element));
      });
    } else if (item.subJobDuty && item.subJobDuty.length > 0) {
      item.subJobDuty.forEach(element => {
        subJobDuty.push(this.buildSubDutyList(element));
      });
    }
    return this.jobDescriptionBuilder.group({
      id: item.id,
      name: item.duty || item.name,
      subJobDuty: this.jobDescriptionBuilder.array(subJobDuty)
    });
  }

  buildSubDutyList(item) {
    return this.jobDescriptionBuilder.group({
      id: item.id,
      name: item.duty || item.name
    });
  }

  // handleOnsaveJobRoleOrPopulateDuties(input: { selectedJobPosition: string, customPositionTitle: string, selectedJobPositionId: number }) {
  //   const overlppingReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, {
  //     ...deleteDialogConfigurations,
  //     data: {
  //       deleteMessage: 'Do you wish to populate duties & sub duties? This will override any existing duties'
  //     }
  //   });
  //   overlppingReconfirmDialogRef.onClose
  //     .pipe(takeUntil(this.observableSubscription$))
  //     .subscribe((response: boolean) => {
  //       if (response) {
  //         if (this.jobDescriptionForm.value && this.jobDescriptionForm.value.id) {
  //           this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType,
  //             this.inputData.caseId, this.jobDescriptionForm.value.id, 0)
  //             .pipe(take(1))
  //             .subscribe((IOSMappingResponse) => {
  //               if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
  //                 const deleteReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, {
  //                   ...deleteDialogConfigurations,
  //                   data: {
  //                     deleteMessage: 'Job duties cannot be populated as Itinerary of Services mapping exists with the job duties. Do you want continue with the deletion of Itinerary of Services mapping?'
  //                   }
  //                 });
  //                 deleteReconfirmDialogRef.onClose
  //                   .pipe(takeUntil(this.observableSubscription$))
  //                   .subscribe((deleteReconfirmResponse: boolean) => {
  //                     if (deleteReconfirmResponse) {
  //                       this.jobDescriptionForm.controls['jobDutyForceDelete'].setValue(true);
  //                       this.populateJobDuties(input);
  //                     }
  //                   });
  //               } else {
  //                 this.populateJobDuties(input);
  //               }
  //             });
  //         } else {
  //           // if there is no position id exists. no need to check ios mapping exists
  //           this.populateJobDuties(input);
  //         }
  //       }
  //     });
  // }

  // populateJobDuties(input) {
  //   (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
  //   this.store.dispatch(new MarkDirtyFormAction({
  //     dirty: true
  //   }));
  //   this.apiService.getJobRolesDuties(this.inputData.companyId,
  //     input.selectedJobPositionId)
  //     .pipe(takeUntil(this.observableSubscription$))
  //     .subscribe((response: any) => {
  //       if (response && response.jobDuty && response.jobDuty.length > 0) {
  //         response.jobDuty.forEach(element => {
  //           element['id'] = null;
  //           if (element.subduty && element.subduty.length > 0) {
  //             element.subduty.forEach(subJobDuty => {
  //               subJobDuty['id'] = null;
  //             });
  //           }
  //           (this.jobDescriptionForm.controls['duties'] as FormArray).push(this.buildDutyList(element));
  //         });
  //       }
  //     });
  // }

  // handleAddUpdateDuty({ type, data, dutyIndex }) {
  //   if (type === 'ADD') {
  //     // If type is ADD then append the job duties to exisiting one
  //     (this.jobDescriptionForm.controls['duties'] as FormArray).push(this.buildDutyList(data));
  //     this.store.dispatch(new MarkDirtyFormAction({
  //       dirty: true
  //     }));
  //   }
  //   if (type === 'UPDATE') {
  //     // If type is UPDATE then update the job duties
  //     (this.jobDescriptionForm.controls['duties'] as FormArray).setControl(dutyIndex, this.buildDutyList(data));
  //     this.store.dispatch(new MarkDirtyFormAction({
  //       dirty: true
  //     }));
  //   }
  // }

  getJobDescription() {
    this.apiService.getJobDescription(this.inputData.visatype, this.inputData.caseType,
      this.inputData.caseId, this.isForeignCompany)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          //this.loadFormValues(response.data);
          this.inputData.jsonInput = { jobCategory: response.data?.jobCategory, jobRole: response.data?.jobRole };
          this.apiService.getJobRoles(this.inputData.companyId).pipe(takeUntil(this.observableSubscription$))
            .subscribe((responseJobRoles: ImagilityBaseResponse) => {
              if (responseJobRoles && responseJobRoles.data && responseJobRoles.data.length > 0 &&
                responseJobRoles.data.find(x => x.jobTitle === response.data['jobRole'])) {
                // predefined job role is selected do nothing
                response.data['otherJobPosition'] = '';
              }
              else {
                // Other option is selected & set the other job position manually
                response.data['otherJobPosition'] = response.data['jobRole'];
                response.data['jobRole'] = 'Other';
              }
              this.loadFormValues(response.data);
            });
        } else {
          // is there is no position details
          this.jobDescriptionForm.reset();
          this.jobDescriptionForm.patchValue({
            selectedRaiobtn: 0,
            jobRole: null
          });
          this.jobDescriptionForm.markAsPristine();
          this.jobDescriptionForm.markAsUntouched();
          this.loadAddress([]);
          this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
        }
      });
  }

  handleWorkLocationChange() {
    this.jobDescriptionForm.get('clientName').setValue(null);
    this.jobDescriptionForm.get('clientPhoneNo').setValue(null);
    this.jobDescriptionForm.get('clientEmail').setValue(null);
    if (this.isFromWizard) {
      this.apiServiceSOC.getLcaSOCCodeSelection(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId).subscribe((response: ImagilityBaseResponse) => {
        if (response) {
            this.lcaCodeId = response?.data?.lcaCodeId;
            if (this.lcaCodeId) {
              // get the lca details.
              this.jobDescriptionLcaWorkLibraryService.getLcaById(this.lcaCodeId).
                subscribe((data: any) => {
                  let phoneDetails = data?.lcaApplication?.company?.phoneContacts.find(x => x.type.code === "OFFC")
                  let addressDetails = data?.lcaApplication?.company?.address.find(x => x.type.code === "MAIL")
                  let emailDetails = data?.lcaApplication?.company?.emailContacts.find(x => x.type.code === "PRIM")
                  this.loadAddress([{...addressDetails,clientName: data?.lcaApplication?.company?.companyName, clientPhoneCode: phoneDetails?.phoneNo, clientEmail: emailDetails?.email}]);
                  this.jobDescriptionForm.patchValue({
                    clientName: data?.lcaApplication?.company?.companyName,
                    clientPhoneNo: phoneDetails?.phoneNo,
                    clientEmail: emailDetails?.email,
                  });
                })
            }
            else {
              CustomErrorToastComponent.showErrorToast(this.toastr, 'Details are not auto populated due to missing lca');
            }
        }
      });
    }else {
      this.loadAddress([]);
    }

  }

  // Load job Desc form with values
  loadFormValues(response) {
    response = {
      ...response,
      isMiddleVendor: response.vendorList && response.vendorList.length > 0,
      // startDate: response.startDate ? new Date(moment(response.startDate).format('MM/DD/YYYY')) : null,
      // endDate: response.endDate ? new Date(moment(response.endDate).format('MM/DD/YYYY')) : null,
      // duties: response.duties ? response.duties : []
    };
    this.jobDescriptionForm.reset({
      ...response,
      selectedRaiobtn: 0,
      jobRole: null
    });
    // this.loadDuties(response.duties);
    this.loadAddress(response.address);
    this.loadVendor(response.vendorList);
  }

  loadVendor(list) {
    (this.jobDescriptionForm.controls['vendorList'] as FormArray).clear();
    if (list && list.length > 0) {
      list.forEach(element => {
        this.createVendorDetailsItem(element);
      });
    }
  }

  loadAddress(list) {
    (this.jobDescriptionForm.controls['address'] as FormArray).clear();
    if (list && list.length > 0) {
      list.forEach(element => {
        this.createAddressItem(element);
      });
    }
    else {
      this.createAddressItem({ id: null });
    }
  }

  // loadDuties(list) {
  //   (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
  //   list.forEach(element => {
  //     (this.jobDescriptionForm.controls['duties'] as FormArray).push(this.buildDutyList(element));
  //   });
  // }

  handleVendorChkboxChange(input) {
    if (input.checked) {
      this.createVendorDetailsItem({});
    } else {
      (this.jobDescriptionForm.controls['vendorList'] as FormArray).clear();
    }
  }

  getCountries() {
    this.cacheCountyService.getCountry().pipe(takeUntil(this.observableSubscription$)).subscribe();
    this.cacheCountyService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
      if (data.listCountries.length > 0) {
        this.countryList = data.listCountries;
      }
    });
  }

  // getWageUnitType() {
  //   this.referenceLibraryService.getReferenceData('PAYTYP')
  //     .pipe(takeUntil(this.observableSubscription$))
  //     .subscribe((response: ReferenceLibrary[]) => {
  //       this.wageUnitType = response;
  //     });
  // }

  // handleDeleteAllDuties() {
  //   if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
  //     // api call to check whether ios is mapped or not
  //     const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
  //     deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response: boolean) => {
  //       if (response) {
  //         // if duty has id and user tries to delete it
  //         this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType,
  //           this.inputData.caseId, this.jobDescriptionForm.value.id, 0)
  //           .pipe(takeUntil(this.observableSubscription$))
  //           .subscribe((IOSMappingResponse) => {
  //             if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
  //               this.handleReconfirmDuty();
  //             }
  //             else {
  //               (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
  //               this.store.dispatch(new MarkDirtyFormAction({
  //                 dirty: true
  //               }));
  //             }
  //           });

  //       }
  //     });
  //   }
  //   else {
  //     (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
  //     this.store.dispatch(new MarkDirtyFormAction({
  //       dirty: true
  //     }));
  //   }
  // }

  // handleReconfirmDuty(dutyIndex: number = null) {
  //   const deleteReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, {
  //     ...deleteDialogConfigurations,
  //     data: {
  //       deleteMessage: 'Job duties cannot be deleted as Itinerary of Services mapping exists with the job duties. Do you want continue with the deletion of Itinerary of Services mapping?'
  //     }
  //   });
  //   deleteReconfirmDialogRef.onClose
  //     .pipe(takeUntil(this.observableSubscription$))
  //     .subscribe((response: boolean) => {
  //       if (response) {
  //         this.jobDescriptionForm.controls['jobDutyForceDelete'].setValue(true);
  //         if (dutyIndex) {
  //           (this.jobDescriptionForm.controls['duties'] as FormArray).removeAt(dutyIndex);
  //         }
  //         else {
  //           (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
  //         }
  //         this.store.dispatch(new MarkDirtyFormAction({
  //           dirty: true
  //         }));
  //       }
  //     });
  // }

  // handleDutyDelete(input: { duty: any, dutyIndex: number }) {
  //   if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
  //     // api call to check whether ios is mapped or not
  //     const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
  //     deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response: boolean) => {
  //       if (response) {
  //         if (input.duty['id']) {
  //           // if duty has id and user tries to delete it
  //           this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType,
  //             this.inputData.caseId, this.jobDescriptionForm.value.id,
  //             this.jobDescriptionForm.value.duties[input.dutyIndex].id)
  //             .pipe(takeUntil(this.observableSubscription$))
  //             .subscribe((IOSMappingResponse) => {
  //               if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
  //                 this.handleReconfirmDuty(input.dutyIndex);
  //               }
  //               else {
  //                 (this.jobDescriptionForm.controls['duties'] as FormArray).removeAt(input.dutyIndex);
  //                 this.store.dispatch(new MarkDirtyFormAction({
  //                   dirty: true
  //                 }));
  //               }
  //             });
  //         }
  //         else {
  //           // direct delete after confirmation without IOS mapping check
  //           (this.jobDescriptionForm.controls['duties'] as FormArray).removeAt(input.dutyIndex);
  //           this.store.dispatch(new MarkDirtyFormAction({
  //             dirty: true
  //           }));
  //         }
  //       }
  //     });
  //   }
  //   else {
  //     (this.jobDescriptionForm.controls['duties'] as FormArray).removeAt(input.dutyIndex);
  //     this.store.dispatch(new MarkDirtyFormAction({
  //       dirty: true
  //     }));
  //   }
  // }

  // handleSubDutyDelete(input: { dutyIndex, subJobDutyIndex }) {
  //   if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
  //     // api call to check whether ios is mapped or not
  //     const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
  //     deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response: boolean) => {
  //       if (response) {
  //         ((this.jobDescriptionForm.controls['duties'] as FormArray)
  //           .controls[input.dutyIndex] as FormArray)
  //           .controls['subJobDuty'].removeAt(input.subJobDutyIndex);
  //         this.store.dispatch(new MarkDirtyFormAction({
  //           dirty: true
  //         }));
  //       }
  //     });
  //   }
  //   else {
  //     ((this.jobDescriptionForm.controls['duties'] as FormArray)
  //       .controls[input.dutyIndex] as FormArray)
  //       .controls['subJobDuty'].removeAt(input.subJobDutyIndex);
  //     this.store.dispatch(new MarkDirtyFormAction({
  //       dirty: true
  //     }));
  //   }
  // }



  postJobDescription() {
    const intermediateObj = Object.assign({}, this.jobDescriptionForm.value);
    intermediateObj.address.forEach((element: any) => {
      delete element['stateList'];
    });
    const { selectedRaiobtn, ...payload } = {
      ...intermediateObj,
      startDate: this.jobDescriptionForm.value.startDate ? moment(this.jobDescriptionForm.value.startDate).format('YYYY-MM-DD') : null,
      endDate: this.jobDescriptionForm.value.endDate ? moment(this.jobDescriptionForm.value.endDate).format('YYYY-MM-DD') : null,
      selectedRaiobtn: intermediateObj.selectedRaiobtn,
      jobRole: intermediateObj.jobRole && intermediateObj.jobRole === 'Other' ? intermediateObj.otherJobPosition : intermediateObj.jobRole
    };
    const APIs = [
      this.apiService.postWorkJobDescription(payload,
        this.inputData.visatype,
        this.inputData.caseType,
        this.inputData.caseId)
    ];
    if (selectedRaiobtn === 1) {
      const selectJobRole = JSON.parse(sessionStorage.getItem('selectedJobRole'));
      const jobDuty = this.jobDescriptionForm.value.duties ?
        this.jobDescriptionForm.value.duties.map(x => {
          return {
            dutyId: x.id ? x.id : 0,
            duty: x.name,
            subduty: x.subJobDuty && x.subJobDuty.length > 0 ?
              x.subJobDuty.map(y => {
                return {
                  dutyId: y.id ? y.id : 0,
                  duty: y.name,
                };
              }) : []
          };
        }) : [];
      const jobRole = {
        id: selectJobRole.id,
        jobDuty,
        jobRoleName: selectJobRole.jobTitle === 'Other' ? this.jobDescriptionForm.value.otherJobPosition : selectJobRole.jobTitle,
        requestFlag: 'updatemasterdata'
      };
      APIs.push(this.apiService.saveJobRole(this.inputData.companyId,
        this.jobDescriptionForm.value.selectedCategory.id, jobRole));
    }
    combineLatest(APIs)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: any[]) => {
        // this.saveMasterDataDuty();
        if (response[0] && response[0].status === 200) {
          this.toastr.success(response[0].message, 'Success');

          if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
            this.updateStepStatus('INPROGRESS');
          }
          else {
            this.getJobDescription();
          }
        }
        if (selectedRaiobtn === 1 && response[1] && response[1].status === 200) {
          this.toastr.success(response[1]['message'], 'Success');
        }
      });
  }

  getSocCode() {
    this.titleSoc = '';
    this.apiService.ongetSOCCode(this.jobDescriptionForm.value.socCode)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(
        data => {
          if (data === null) {
            this.titleSoc = 'No SOC occupation title found';
            this.jobDescriptionForm.patchValue({
              socTitle: null,
            });
          } else {
            // this.socTitle = data.title;
            this.titleSoc = '';
            this.jobDescriptionForm.patchValue({
              socTitle: data.title,
            });
          }
        });
  }

  updateStepStatus(status) {
    this.store.dispatch(
      updateStepStatus({
        payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
        subTaskId: this.stepDetails.taskId,
        visaType: this.inputData.caseType === 'I130' ?
          this.inputData.caseType : this.inputData.visatype,
        stepId: this.inputData.stepId
      }));
  }

  // Toggle controls status based on step status
  toggleControlsStatus() {


    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);

    // console.log('toggleControlsStatus ::', this.disabledControls);

    this.fileUploadConfigurations = Object.assign({}, {
      disableControls: this.disabledControls,
      isDocumentTypeRequired: true,
      isDocumentUploadRequired: true,
      isViewEnabled: true,
      isDownloadEnabled: true,
      isDeleteEnabled: true,
      getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/`,
      postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/fileCategory/`,
      deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
      documentTypeDropdownCode: (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR',
      getDocTypeApiUrl: '/referenceLibrary/POSOFFRLTR'
      // getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/`,
      // postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/fileCategory/`,
      // deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
      // documentTypeDropdownCode: this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'OFFLTR'
    });
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  handleCancel() {
    this.getJobDescription();
  }

  handleAddLocationClick() {
    this.createAddressItem({ id: 0 });
  }

  handleDeleteWorkLocation(input, index) {
    const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
    deleteDialogRef.onClose
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: boolean) => {
        if (response) {
          if (input.value && input.value.workLocationId) {
            this.apiService.deleteWorkLocation(this.inputData.visatype, this.inputData.caseType,
              this.inputData.caseId, input.value.workLocationId)
              .pipe(takeUntil(this.observableSubscription$))
              .subscribe((response: ImagilityBaseResponse) => {
                if (response) {
                  this.toastr.success(response.message, 'Success');
                  (this.jobDescriptionForm.controls['address'] as FormArray).removeAt(index);
                  if ((this.jobDescriptionForm.controls['address'] as FormArray).length <= 0) {
                    this.handleAddLocationClick();
                  }
                }
              });
          }
          else {
            (this.jobDescriptionForm.controls['address'] as FormArray).removeAt(index);
            this.toastr.success('Deleted Successfully', 'Success');
            if ((this.jobDescriptionForm.controls['address'] as FormArray).length <= 0) {
              this.handleAddLocationClick();
            }
          }
        }
      });
  }

  onWageUnitChange(event) {
    switch (event.value) {
      case 'HOUR':
        this.jobDescriptionForm.controls['wagesPerYear'].setValue(2080 * this.jobDescriptionForm.controls['wagesFrom'].value);
        break;
      case 'WEEK':
        this.jobDescriptionForm.controls['wagesPerYear'].setValue(52 * this.jobDescriptionForm.controls['wagesFrom'].value);
        break;
      case 'BIWEEK':
        this.jobDescriptionForm.controls['wagesPerYear'].setValue(26 * this.jobDescriptionForm.controls['wagesFrom'].value);
        break;
      case 'MONTH':
        this.jobDescriptionForm.controls['wagesPerYear'].setValue(12 * this.jobDescriptionForm.controls['wagesFrom'].value);
        break;
      case 'YEAR':
        this.jobDescriptionForm.controls['wagesPerYear'].setValue(this.jobDescriptionForm.controls['wagesFrom'].value);
        break;
    }
  }
  clientNameRequired(control: FormControl): { [s: string]: boolean } {
    if (this.jobDescriptionForm &&
      (this.jobDescriptionForm.value.workLocationTypeCode && ['TPARTY','INHSECLT'].includes(this.jobDescriptionForm.value.workLocationTypeCode)) &&
      !control.value) {
      return { clientNameIsRequired: true };
    }
    return null;
  }

  onDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }

}


// @Injectable({
//   providedIn: 'root'
// })
// export class DateValidators {
//   dateLessThan(dateField1: string, dateField2: string) {
//     return (formGroup: FormGroup) => {
//       const date1 = formGroup.get(dateField1).value;
//       const date2 = formGroup.get(dateField2).value;
//       if ((date1 !== null && date2 !== null) && date1 > date2) {
//         formGroup.get(dateField2).setErrors({ positionDateValidation: true });
//       }
//       else {
//         formGroup.get(dateField2).setErrors(null);
//       }
//     };
//   }
// }
